export default __webpack_public_path__ + "static/image4-420ff29623f4dcd92fd39be58404fbec.webp";